import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, fade } from '@material-ui/core/styles';
import { Button, ButtonGroup } from '@material-ui/core';
import {
  Archive as ArchiveIcon,
  Description as DocumentiIcon,
} from '@material-ui/icons';

export const VISTE = [
  { valore: 'documenti', etichetta: 'Allegati', Icona: DocumentiIcon },
  { valore: 'archivio', etichetta: 'Archivio', Icona: ArchiveIcon },
];

// A pair of buttons and not a second row of tabs: the section already sits
// under the esercizio's own tabs, and another tab strip right below them reads
// as a second navigation level of the page. The selected one takes the brand
// tint of the section's selected states.
const useStyles = makeStyles((theme) => ({
  root: {
    marginBottom: theme.spacing(3),
  },
  bottone: {
    borderRadius: theme.shape.controlRadius,
    color: theme.palette.text.secondary,
    borderColor: theme.palette.divider,
    fontWeight: 500,
    padding: theme.spacing(0.75, 2),
  },
  attivo: {
    backgroundColor: fade(theme.palette.primary.main, 0.12),
    color: theme.palette.primary.dark,
    fontWeight: 600,
    '&:hover': {
      backgroundColor: fade(theme.palette.primary.main, 0.18),
    },
  },
}));

/** The switch between the active documents and the archived ones. */
export default function VistaDocumentiToggle({ vista, onChange }) {
  const classes = useStyles();

  return (
    <ButtonGroup
      className={classes.root}
      variant="outlined"
      aria-label="Allegati o archivio"
    >
      {VISTE.map(({ valore, etichetta, Icona }) => {
        const attiva = valore === vista;
        return (
          <Button
            key={valore}
            aria-pressed={attiva}
            startIcon={<Icona fontSize="small" />}
            className={`${classes.bottone} ${attiva ? classes.attivo : ''}`}
            onClick={() => onChange(valore)}
          >
            {etichetta}
          </Button>
        );
      })}
    </ButtonGroup>
  );
}

VistaDocumentiToggle.propTypes = {
  vista: PropTypes.oneOf(VISTE.map(({ valore }) => valore)).isRequired,
  onChange: PropTypes.func.isRequired,
};
